import CrudController from "./crud_controller";

export default class extends CrudController {
  connect() {
    this.siteNum = this.data.get("siteNum");
    this.loadList();
  }

  loadList() {
    this.clearMessage();
    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/notes`), this.listTarget)
      .then(() => {
        if(window.App.EDIT_MODE) this.showNewLink();
      });
  }

  new(event) {
    this.clearMessage();
    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/notes/new`), this.listTarget)
      .then(() => {
        this.hideNewLink();
      });
  }

  edit(event) {
    let div = document.createElement("div");
        div.classList.add("circle-loader");

    let button = event.target.closest("button");

    button.replaceWith(div);

    this.clearMessage();
    let seqNum = event.currentTarget.dataset.seqNum;
    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/notes/${seqNum}/edit`), this.listTarget)
      .then(() => {
        this.hideNewLink();
         div.replaceWith(button);
      });
  }
}